import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";
import { AuthProvider, useAuth } from "./context/AuthContext";
import Layout from "./components/Layout";
import Login from "./pages/Login";
import Dashboard from "./pages/Dashboard";
import Garanzie from "./pages/Garanzie";
import GaranziaDetail from "./pages/GaranziaDetail";
import Certificato from "./pages/Certificato";
import Reclami from "./pages/Reclami";
import Veicoli from "./pages/Veicoli";
import Clienti from "./pages/Clienti";
import Utenti from "./pages/Utenti";
import Assistente from "./pages/Assistente";
import Impostazioni from "./pages/Impostazioni";

const Protected = ({ children, admin }) => {
  const { user } = useAuth();
  if (user === null) return <div className="flex min-h-screen items-center justify-center text-sm text-muted-foreground">Caricamento…</div>;
  if (!user) return <Navigate to="/login" replace />;
  if (admin && user.role !== "admin") return <Navigate to="/" replace />;
  return children;
};

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/garanzie/:id/certificato" element={<Protected><Certificato /></Protected>} />
          <Route element={<Protected><Layout /></Protected>}>
            <Route index element={<Dashboard />} />
            <Route path="garanzie" element={<Garanzie />} />
            <Route path="garanzie/:id" element={<GaranziaDetail />} />
            <Route path="reclami" element={<Reclami />} />
            <Route path="veicoli" element={<Veicoli />} />
            <Route path="clienti" element={<Clienti />} />
            <Route path="assistente" element={<Assistente />} />
            <Route path="utenti" element={<Protected admin><Utenti /></Protected>} />
            <Route path="impostazioni" element={<Protected admin><Impostazioni /></Protected>} />
          </Route>
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
      <Toaster richColors position="top-right" />
    </AuthProvider>
  );
}

export default App;
